import type { EditorAPI } from '#packages/editorAPI';
import { leftBarActions } from '#packages/stateManagement';

export const overrideLeftBar = (
  editorAPI: EditorAPI,
  leftBarOverriding: {
    desktop?: Array<{ key: string }>;
    mobile?: Array<{ key: string }>;
  },
) => {
  const action = leftBarActions.overrideItems(leftBarOverriding);
  editorAPI.store.dispatch(action);
};
